<template>
    <div v-show="config.isVisible" :class="['master-table-cell', cellClasses, classes]" v-on="$listeners">
        <div class="master-table-cell-content">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'MasterTableCell',
    
    inject: ['table'],

    props: {
        isNumeric: Boolean,
        isMonetary: Boolean,
        config: Object,
        label: String,
        classes: Array,
        sortBy: String,
        centered: {
            type: Boolean,
            default: false
        }
    },
    
    computed: {
        cellClasses() {
            return {
                'numeric': this.isNumeric,
                'monetary': this.isMonetary,
                'centered': this.centered
            }
        }
    }
}
</script>

<style scoped>
.master-table-cell {
    padding: 0px 15px;
    height: 52px;
    display: flex;
    flex: 1;
    min-width: 200px;
    width: 200px;
    max-width: 200px;
    align-items: center;
    font-size: 14px;
    color: #877d88;
    position: relative;
    border-right: 1px solid #f4f5f9;
}

.master-table-cell .master-table-cell-content {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 100%;
    width: 100%;
}

.master-table-cell.hidden {
    display: none;
}

.master-table-row > div:last-of-type {
    width: auto;
    border-right: none;
}

.master-table-cell img {
    height: inherit;
}

.master-table-cell p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.master-table-cell.numeric {
    justify-content: flex-end;
}

.master-table-cell.centered {
    justify-content: center;
}

.master-table-cell.monetary {
    color: #2ADA2B;
    font-weight: 900;
}

.master-table-cell.dropdown-cell .master-table-cell-content {
    height: 40px;
}

.master-table-cell.number,
.master-table-cell.date {
    text-align: center;
}
</style>
